<section *ngIf="data" data-dte-section="content">
    <div class="container">
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>
</section>

<ng-template #content>
    <h1 *ngIf="data?.headline" [innerHtml]="data.headline"></h1>
    <div *ngIf="data?.copytext.value" [innerHtml]="data.copytext.value" class="large"></div>
    <div class="boxes">
        <!-- insert boxes -->
        <da-show-more
            *ngIf="numberOfVisibleBoxes > 0"
            [backgroundColor]="data._options.background === 'background-color-nearwhite' ? 'nearwhite' : 'white'"
            [buttonLabelMore]="data._options.showMoreButtonText"
            [labelMore]="'common.labelMore' | translate"
            [labelLess]="'common.labelLess' | translate"
            (toggle)="toggleShowMore($event)"
        >
        </da-show-more>
    </div>
</ng-template>
